import { useState, useEffect, useCallback } from 'react';

/**
 * Спільний стан шапки «Користувачі» (/admin/users) — РЕДИЗАЙН.
 *
 * У топбар винесено вибір тенанта й пошук (§6): раніше тенанти жили у власній
 * лівій колонці шириною 224px, патерну якої немає більше ніде в кабінеті.
 *
 * Перелік тенантів кладе сюди ТІЛО сторінки після завантаження — топбар лише
 * малює опції й нічого не фетчить (як setRange у useMarketPricesUi).
 */
const EV = 'helios:users-ui-change';

export interface UsersTenantOpt { id: string; name: string }

const state = {
  tenantId: '' as string,
  search: '' as string,
  tenants: [] as UsersTenantOpt[],
};

const emit = () => window.dispatchEvent(new CustomEvent(EV));

export function useUsersUi() {
  const [, force] = useState(0);
  useEffect(() => {
    const refresh = () => force((x) => x + 1);
    window.addEventListener(EV, refresh);
    return () => window.removeEventListener(EV, refresh);
  }, []);

  /** Зміна тенанта скидає пошук — та сама поведінка, що була в handleTenantSelect. */
  const setTenantId = useCallback((id: string) => {
    if (state.tenantId !== id) { state.tenantId = id; state.search = ''; emit(); }
  }, []);
  const setSearch = useCallback((v: string) => { if (state.search !== v) { state.search = v; emit(); } }, []);
  const setTenants = useCallback((list: UsersTenantOpt[]) => {
    const same = list.length === state.tenants.length && list.every((x, i) => x.id === state.tenants[i]?.id);
    if (!same) { state.tenants = list; emit(); }
  }, []);

  return {
    tenantId: state.tenantId, search: state.search, tenants: state.tenants,
    setTenantId, setSearch, setTenants,
  };
}
